import styled, { css } from 'styled-components';

export const WrapperLinkButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 80%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
      min-width: 180px;
      justify-content: flex-start;
    }
  `}
`;

export const ButtonSiteCreator = styled.button`
  ${() => css`
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
  `}
`;

export const TitleButton = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.brand.primaryMedium};
    margin-left: 8px;
    margin-top: 0;
    margin-bottom: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
